module.exports = __webpack_public_path__ + "img/kaist_detail.e038d1cb.jpg";